module.exports = "<div *ngIf='show' class='info-detail'>\r\n    <div class='close text-right' (click)='closeDetail($event)'>\r\n        <i class='zmdi zmdi-close' style=\"color: black;\"></i>\r\n    </div>\r\n    <div>\r\n         <p>  <a [routerLink] = \"['../../main/patient/patientprofile', item.TaskId]\" [ngStyle]=\"{'color':item.Color}\">{{detail.TaskName}}</a></p>\r\n          <p> {{detail.Time}}</p>\r\n        </div>\r\n    </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/appointment/calendar/show-task.component.html
// module id = ./src/app/section/appointment/calendar/show-task.component.html
// module chunks = main